//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import UpcomingActivitiesContainer from "./activities-tab-components/upcoming-activities-container";
import ClientActivitiesContainer from "./activities-tab-components/client-activities-container";
import ActivityFilter from "./activities-tab-components/activity-filter";
import { defineComponent } from "@vue/composition-api";
export const ActivitiesTabs = {
  UpcomingActivities: "upcoming-activities",
  ClientActivities: "client-activities"
};
export default defineComponent({
  name: "ActivitiesTab",
  components: {
    UpcomingActivitiesContainer,
    ClientActivitiesContainer,
    ActivityFilter
  },
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    filters: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      currentPage: ActivitiesTabs.UpcomingActivities,
      ActivitiesTabs
    };
  },
  methods: {
    setCurrentPage(page) {
      this.currentPage = page;
    },
    handleActivityFilter(args) {
      this.$emit("filter-change", args);
    }
  }
});